module.exports = __webpack_public_path__ + "static/media/Mocidade_2025.5813e263.png";